<div (click)="open('/main/signal-strength-analysis')"
     class="rounded-2 border-3 border-bottom background-pure-white p-3 pointer pointer-hover height-100px">
    <div class=" d-flex justify-content-between">
        <div class=" fs-main fw-bold mb-3">Signal-strength analysis</div>
        <div class=" mt-auto mb-auto">
            <i class="color-primary-blue fa-solid fa-chevron-right fa-lg"></i>
        </div>
    </div>
    <div class="row">
        <div class="col col-auto">
            <app-gateway-svg
                backgroundColor="white"
                class="img-fluid img-max m-0"
                height="30px"
                width="30px"/>
        </div>
    </div>
</div>
